const setRouteName = (): string => {
  let res;
  if (typeof window !== "undefined") {
    res = window.location.pathname.slice(1, -1).split("/").join("-") || "home";
  }
  return res;
};

export default setRouteName;
